import type { QBOCategory } from '@/services/qbo'

export function filterCreditCardCategories(categories: QBOCategory[]): QBOCategory[] {
  return categories.filter((c) => c.account_type === 'Credit Card')
}
